import { Component } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import * as preloadData from '../../shared/content/preloadData.json';

@Component({
  selector: 'app-preload',
  templateUrl: './preload.component.html',
  styleUrls: ['./preload.component.css'],
  animations: [
    trigger("fadeInOut", [
      state("open", style({ opacity: 1 })),
      state("closed", style({ opacity: 0 })),
      transition("open <=> closed", animate("3000ms")),
    ])
  ]
})

export class PreloadComponent {
  public lodingCount: number = 0;
  public counterValue: any = 0;
  public preloadObject: any = preloadData;

  constructor() {
    this.preloadImage(this.preloadObject.imageArray);
    this.preloadAudio(this.preloadObject.audioArray)
  }

  preloadImage(imgArr: any): void {
    let imagePreCount = 0;
    for (let pId = 0; pId < imgArr.length; pId++) {
      let img = new Image();
      let _that = this;
      img.onload = function () {
        _that.checkLoaded();
      }
      img.src = this.preloadObject.commonImgPath + imgArr[pId];
    }
  }
  preloadAudio(audioArr: any): void {
    let audioPreCount = 0;
    var self = this;
    for (let index in audioArr) {
      let myaudio = new Audio();
      myaudio.preload = 'auto';
      let self = this;
      myaudio.addEventListener('error', function failed(e) {
        // console.log('e.target', e.target)
      })
      myaudio.addEventListener('canplaythrough', function () {
      }, false);
      myaudio.src = this.preloadObject.commonAudioPath + audioArr[index];
    }
  }
  checkLoaded() {
    this.lodingCount++;
    this.counterValue = ((this.lodingCount / (this.preloadObject.imageArray.length)) * 100).toFixed(0);
  }
}
